<template>
    <div class="c-header">
        <div class="c-headers">
            <div class="logo">
              <router-link tag="a" to="/">
                <img class="logo-img" src="@/assets/logo.png"><span class="logo-img-text">Sysale OrderBot</span>
              </router-link>
            </div>
            <ul class="nav-right" v-if="xAppTool.isLogin()">
              <li>
                <iframe width="190" scrolling="no" height="60" frameborder="0" allowtransparency="true" src="//i.tianqi.com/index.php?c=code&id=12&color=%23FFFFFF&icon=1&num=1&site=12"></iframe>
              </li>
              <!--<li class="split"></li>-->
              <!--<li>-->
                <!--<div class="grow-txt">成长值</div>-->
                <!--<div class="grow-num">{{grow_num}}</div>-->
              <!--</li>-->
              <!--<li class="split"></li>-->
              <!--<li>-->
                <!--<el-badge is-dot class="bell-item" :hidden="msg_num>0?false:true">-->
                  <!--<i class="el-icon-bell"></i>-->
                <!--</el-badge>-->
              <!--</li>-->
              <!--<li class="split"></li>-->
              <li>
                <div class="user-txt">{{xAppTool.getLoginUserInfo().name}}</div>
                <el-dropdown @command="handleCommand">
                  <div class="user-img"><img :src="xAppTool.getLoginUserInfo().avatar"></div>
                  <el-dropdown-menu slot="dropdown">
                    <!--<el-dropdown-item command="changePsw"><i class="el-icon-setting"></i> 设置 </el-dropdown-item>-->
                    <!--<el-dropdown-item divided command="help"><i class="el-icon-question"></i> 帮助 </el-dropdown-item>-->
                    <el-dropdown-item divided command="qq"> 技术客服 </el-dropdown-item>
                    <el-dropdown-item divided command="logout"><i class="el-icon-error"></i> 退出 </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            has_weather: false,
            weather_temp: '',
            weather_name: '',
            weather_icon: '',
            grow_num: 0,
            msg_num: 0
        }
    },
    methods:{
        handleCommand:function(command){
            if (command == 'changePsw') {
                this.$router.push({path: '/password'})
            }
            else if (command == 'logout') {
                this.xAppTool.store.clear();
                this.$router.push({path: '/login'})
            }else if(command == 'qq'){
                window.open('//wpa.qq.com/msgrd?v=3&uin=3368180746&site=qq&menu=yes');
            }
        }
    },
    mounted: function () {
        let self = this;

        // 成长值（接口+缓存） ×
        self.grow_num = 0;

        // 新消息数（接口+缓存） ×
        self.msg_num = 2;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .c-header {height: 60px;background: #409EFF;}
    .c-header .c-headers{ margin: 0 auto; }
    .c-header .logo{ padding-left: 20px }
    .c-header .logo-img{ float: left;height: 36px;margin: 12px 0px 0px 0px  }
    .c-header .logo-img-text{ float: left;height: 36px;margin: 20px 0px 0px 15px;color: #ffffff;font-size: 18px  }
    .c-header .nav-right{ float: right;list-style: none;margin: 0;padding: 0;font-size: 12px;color: #fff }
    .c-header .nav-right li {float: left;margin: 0;padding: 0px 32px}
    .c-header .nav-right li.split{
        width: 2px;
        height:30px;
        padding: 0;
        margin-top: 15px;
        background: #A7D8FF;
    }
    .weather-txt{ float: left }
    .weather-txt .w-t{ font-size: 20px;color: #fff;line-height: 20px;margin-top: 14px }
    .weather-txt .w-b{ font-size: 12px;color: #fff;padding-left: 5px }
    .weather-img{ float: left }
    .weather-img img{ height:24px;margin: 18px 0px 0px 8px  }
    .grow-txt{ float: left;line-height: 60px }
    .grow-num{ float: left;line-height: 60px; font-size: 18px;margin-left: 15px; }
    .bell-item{ font-size: 16px;margin-top: 22px }
    .user-txt{ float: left;line-height: 60px;color: #fff;font-size: 12px }
    .user-img{ float: left;cursor: pointer }
    .user-img img{ height: 40px;margin-top: 10px;margin-left: 20px }
</style>
<style>
    /*放到这里才有效果*/
    .bell-item .is-dot{
        width: 6px;
        height: 6px;
        background-color: rgba(161, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(161, 255, 255, 1);
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/common-header.vue